import { render, staticRenderFns } from "./KazangMobileMoney.vue?vue&type=template&id=ca08ee86&scoped=true&"
import script from "./KazangMobileMoney.vue?vue&type=script&lang=js&"
export * from "./KazangMobileMoney.vue?vue&type=script&lang=js&"
import style0 from "./KazangMobileMoney.vue?vue&type=style&index=0&id=ca08ee86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca08ee86",
  null
  
)

export default component.exports